import React from 'react';
import type { DeepLinkScreenCatalogItem } from '../../../models/MasterAdmin/deepLink';

export function RouteSeedStatusBadge({ hasDbRoute }: { hasDbRoute: boolean }) {
  return hasDbRoute ? (
    <span className="inline-flex rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200">
      Seeded
    </span>
  ) : (
    <span className="inline-flex rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-900 dark:bg-amber-950/50 dark:text-amber-200">
      Pending seed
    </span>
  );
}

export function ScreenSeedHint({ screen }: { screen: DeepLinkScreenCatalogItem | null }) {
  if (!screen) return null;
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
      <RouteSeedStatusBadge hasDbRoute={screen.hasDbRoute} />
      {!screen.hasDbRoute ? (
        <span>Selecting this screen will auto-create the route in the database.</span>
      ) : (
        <span>Route slug: <code className="text-gray-700 dark:text-gray-300">{screen.slug}</code></span>
      )}
    </div>
  );
}
